export default function createAuthenticatedPageLogger(baseLog) {
    const log = (input) => baseLog({ ...input, type: `authenticated-page:${input.type}` });
    return {
        opened(type, url) {
            return log({
                type: "opened",
                details: { type, url },
            });
        },
        detected(type) {
            return log({
                type: "detected",
                details: { type },
            });
        },
        authenticateMessageSent(message) {
            return log({
                type: "authenticate-message:sent",
                details: { message },
            });
        },
        authenticateMessageReceived(sender, message) {
            return log({
                type: "authenticate-message:received",
                details: { sender, message },
            });
        },
        authCodeSent(origin, accountId) {
            return log({
                type: "auth-code:sent",
                details: { origin, accountId },
            });
        },
        authCodeReceived(sender, message) {
            return log({
                type: "auth-code:received",
                details: { sender, message },
            });
        },
        authCodeExchanged(accountId, userId) {
            return log({
                type: "auth-code:exchanged",
                details: { accountId, userId },
            });
        },
        authenticated(accountId, userId) {
            return log({
                type: "authenticated",
                details: { accountId, userId },
            });
        },
        authenticationSkipped(reason) {
            return log({
                type: "authentication-skipped",
                details: { reason },
            });
        },
    };
}
